import React from 'react';

import DividendsFinalAnnouncements from './DividendsFinalAnnouncements';
import { getDividendsFinalAnouncements } from '../../utils/api';

const DividendsFinalAnnouncementsPublic = props => <DividendsFinalAnnouncements endpoint={getDividendsFinalAnouncements} {...props} />

export default DividendsFinalAnnouncementsPublic
